<template>
    <section class="ksa-benefits-section bg-white container-global q-py-xl">
        <div class="ksa-benefits-container">
            <div class="ksa-benefits-right">
                <div class="ksa-benefit-item" :class="{ 'ksa-benefit-item--active': activeKsaBenefitIndex === 0 }"
                tabindex="0"  role="button"    @click="setActiveKsaBenefit(0)">
                    <div class="ksa-benefit-number">1</div>
                    <div class="ksa-benefit-content">
                        <div class="ksa-benefit-title">فـهم عميق للثقافة الوطنية</div>
                        <div class="ksa-benefit-desc">
                            مما يساهم بتقييم اللغة المستخدمة في موقعك، ووجود نماذج اختبار عربية تناسب ثقافة المستخدم
                            وسهلة الاستخدام </div>
                    </div>
                </div>
                <div class="ksa-benefit-item" :class="{ 'ksa-benefit-item--active': activeKsaBenefitIndex === 1 }"
                tabindex="0"  role="button"        @click="setActiveKsaBenefit(1)">
                    <div class="ksa-benefit-number">2</div>
                    <div class="ksa-benefit-content">
                        <div class="ksa-benefit-title">الإسهام في رفع جودة المنتجات الرقمية</div>
                        <div class="ksa-benefit-desc">
                            في ظل التحول الرقمي، أداة أكواد تيسر لك سبل الالتزام بأفضل الممارسات في مجالات تجربة
                            المستخدم </div>
                    </div>
                </div>
                <div class="ksa-benefit-item" :class="{ 'ksa-benefit-item--active': activeKsaBenefitIndex === 2 }"
                tabindex="0"  role="button"          @click="setActiveKsaBenefit(2)">
                    <div class="ksa-benefit-number">3</div>
                    <div class="ksa-benefit-content">
                        <div class="ksa-benefit-title">المواءمة مع المعايير المحلية</div>
                        <div class="ksa-benefit-desc">
                            استخدامك لأداة أكواد يعني التزامك بأفضل المعايير المحلية ومؤشرات النضج الرقمي والمعايير
                            الوطنية </div>
                    </div>
                </div>
                <div class="ksa-benefit-item" :class="{ 'ksa-benefit-item--active': activeKsaBenefitIndex === 3 }"
                tabindex="0"  role="button"           @click="setActiveKsaBenefit(3)">
                    <div class="ksa-benefit-number">4</div>
                    <div class="ksa-benefit-content">
                        <div class="ksa-benefit-title">استضافة محلية داخل السعودية</div>
                        <div class="ksa-benefit-desc">ضمان حفظ البيانات داخل المملكة بما يتماشى مع الأنظمة الوطنية، مع
                            تحسين أداء النظام ورفع مستوى الأمان السبراني</div>
                    </div>
                </div>
            </div>
            <div class="ksa-benefits-left">
                <div class="ksa-benefits-image-placeholder">
                    <div class="ksa-benefits-image-placeholder-inner"
                        :class="{ 'ksa-benefits-image-placeholder-inner--active': activeKsaBenefitIndex === 0 }">
                        <img src="@/assets/images/new-home/ksa-benefit-item-1.svg"
                            alt="أكواد – أداة سعودية لتقييم تجربة المستخدم وتحسين أداء المواقع والمنتجات الرقمية" />
                    </div>
                    <div class="ksa-benefits-image-placeholder-inner"
                        :class="{ 'ksa-benefits-image-placeholder-inner--active': activeKsaBenefitIndex === 1 }">
                        <img src="@/assets/images/new-home/ksa-benefit-item-2.svg"
                            alt="تحليل تجربة المستخدم مع تقارير احترافية مدعومة بالذكاء الاصطناعي" />
                    </div>
                    <div class="ksa-benefits-image-placeholder-inner"
                        :class="{ 'ksa-benefits-image-placeholder-inner--active': activeKsaBenefitIndex === 2 }">
                        <img src="@/assets/images/new-home/ksa-benefit-item-3.svg"
                            alt="اختبارات قابلية الاستخدام لاكتشاف مشاكل واجهة المستخدم وتحسينها" />
                    </div>
                    <div class="ksa-benefits-image-placeholder-inner"
                        :class="{ 'ksa-benefits-image-placeholder-inner--active': activeKsaBenefitIndex === 3 }">
                        <img src="@/assets/images/new-home/ksa-benefit-item-4.svg"
                            alt="خبراء تجربة المستخدم يقدمون مراجعات احترافية للمواقع والخدمات الرقمية" />
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script setup lang="ts">
import { ref, onMounted, onUnmounted } from 'vue';

// Props to accept initial active index
const props = withDefaults(defineProps<{
    initialActiveIndex?: number;
}>(), {
    initialActiveIndex: 3
});

// KSA Benefits state
const activeKsaBenefitIndex = ref(props.initialActiveIndex);

// Auto-rotation variables
const autoRotationInterval = ref<number | null>(null);
const totalItems = 4; // Total number of KSA benefit items
const rotationInterval = 6000; // 6 seconds in milliseconds

const setActiveKsaBenefit = (index: number) => {
    activeKsaBenefitIndex.value = index;
    // Reset auto-rotation timer when user manually clicks
    resetAutoRotation();
};

const nextKsaBenefit = () => {
    activeKsaBenefitIndex.value = (activeKsaBenefitIndex.value + 1) % totalItems;
};

const startAutoRotation = () => {
    autoRotationInterval.value = window.setInterval(() => {
        nextKsaBenefit();
    }, rotationInterval);
};

const resetAutoRotation = () => {
    if (autoRotationInterval.value) {
        clearInterval(autoRotationInterval.value);
    }
    startAutoRotation();
};

const stopAutoRotation = () => {
    if (autoRotationInterval.value) {
        clearInterval(autoRotationInterval.value);
        autoRotationInterval.value = null;
    }
};

// Lifecycle hooks
onMounted(() => {
    startAutoRotation();
});

onUnmounted(() => {
    stopAutoRotation();
});
</script>

<style scoped lang="scss">
.ksa-benefits-section {
    width: 100%;
    background: #fff;
    margin: 0 auto 32px auto;
    padding: 0;
    display: flex;
    justify-content: center;
}

.ksa-benefits-container {
    display: flex;
    justify-content: center;
    align-items: stretch;
    gap: 48px;
    width: 100%;
    padding: 0 12px;
}

.ksa-benefits-left {
    flex: 1 1 50%;
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    height: 100%;
}

.ksa-benefits-image-placeholder {
    width: 100%;
    height: 100%;
    border: 8px solid #F2F2F2;
    border-radius: 16px;
    background: #fff;
    margin: 0 0 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;

    .ksa-benefits-image-placeholder-inner {
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        opacity: 0;
        transform: scale(0.8);
        transition: all 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94);
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) scale(0.8);

        img {
            max-width: 80%;
            max-height: 80%;
            width: auto;
            height: auto;
            object-fit: contain;
        }

        &.ksa-benefits-image-placeholder-inner--active {
            opacity: 1;
            transform: translate(-50%, -50%) scale(1);
        }
    }
}

.ksa-benefits-right {
    flex: 1 1 50%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: 18px;
    margin-top: 12px;
}

.ksa-benefit-item {
    display: flex;
    align-items: flex-start;
    gap: 18px;
    margin-bottom: 8px;
    padding: 16px 18px 16px 8px;
    border-radius: 12px;
    background: transparent;
    transition: all 0.3s cubic-bezier(0.25, 0.46, 0.45, 0.94);
    cursor: pointer;
    border: 2px solid transparent;

    &:hover {
        background: #F5F5F5;
        border-color: #E0E0E0;
    }
}

.ksa-benefit-item--active {
    background: #F5F5F5;
    font-weight: 700;
    border-color: #9c9c9c;
    box-shadow: 0 4px 12px rgba(76, 77, 79, 0.1);
}

.ksa-benefit-number {
    font-size: 1.6rem;
    font-weight: 700;
    color: var(--bs-text-color);
    min-width: 36px;
    text-align: center;
    margin-top: 2px;
    background: transparent;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}

.ksa-benefit-item--active .ksa-benefit-number {
    color: var(--bs-white);
    background: var(--bs-text-color);
    font-weight: 900;
    width: 36px;
    height: 36px;
}

.ksa-benefit-content {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 4px;
}

.ksa-benefit-title {
    font-size: 1.1rem;
    font-weight: 700;
    color: var(--bs-text-color);
    margin-bottom: 2px;
}

.ksa-benefit-desc {
    font-size: 0.98rem;
    color: var(--bs-text-color-secondary);
    font-weight: 400;
    line-height: 1.7;
    max-width: 350px;
}

@media (max-width: 1100px) {
    .ksa-benefits-container {
        flex-direction: column-reverse;
        align-items: center;
        gap: 24px;
    }

    .ksa-benefits-left,
    .ksa-benefits-right {
        width: 100%;
        justify-content: center;
        align-items: center;
    }

    .ksa-benefits-image-placeholder {
        width: 90vw;
        max-width: 350px;
        height: 40vw;
        max-height: 350px;
    }

    .ksa-benefits-right {
        margin-top: 0;
        align-items: center;
    }

    .ksa-benefit-content {
        align-items: flex-start;
    }
}

@media (max-width: 600px) {
    .ksa-benefits-image-placeholder {
        width: 90vw;
        max-width: 250px;
        height: 60vw;
        max-height: 250px;
    }

    .ksa-benefit-title {
        font-size: 1rem;
    }

    .ksa-benefit-desc {
        font-size: 0.92rem;
    }
}
</style>